import * as Sentry from '@sentry/react';

// Sentry is this site's crash/error reporting — Firebase Crashlytics is
// Android/iOS/Unity only, it has no web SDK, so it can't cover a React site.
// Same no-op-until-configured pattern as firebase.ts: without a DSN this is
// a harmless skip, not a crash, so local dev without a Sentry account still
// works fine.
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) {
    console.warn('[sentry] Error reporting not configured — missing VITE_SENTRY_DSN environment variable.');
    return;
  }
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
  });
}

export { Sentry };
